export default __webpack_public_path__ + "static/media/offline.802a030d.svg";